// FLAGS: none
// Debounced employer picker for the client form.
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useEmployersQuery } from "@src/queries/employers";
import { useDebounce } from "use-debounce";
import { FC, useState } from "react";
import {
  ModelsEmployer,
  RequestClientCreateRequest,
} from "@src/api/v1/data-contracts";
import { FormikProps } from "formik";

interface EmployersAutocompleteProps {
  onChange: (value: ModelsEmployer | null) => void;
  employerId: string | null;
  name: string;
  label: string;
  formik: FormikProps<RequestClientCreateRequest>;
}

const EmployersAutocomplete: FC<EmployersAutocompleteProps> = ({
  onChange,
  employerId,
  name,
  label,
  formik,
  ...props
}) => {
  const [employerSearchTerm, setEmployerSearchTerm] = useState<string>("");
  const [debouncedTerm] = useDebounce(employerSearchTerm, 500);
  const { data: employers } = useEmployersQuery(debouncedTerm);

  return (
    <Autocomplete<ModelsEmployer>
      {...props}
      options={employers ?? []}
      getOptionLabel={(employer) => employer?.name ?? ""}
      onInputChange={(_, newInputValue) => setEmployerSearchTerm(newInputValue)}
      filterOptions={(x) => x}
      onChange={(_, newValue) => onChange(newValue)}
      value={
        employers?.find(
          (employer: ModelsEmployer) => employer.id === employerId,
        ) || null
      }
      renderInput={(params) => (
        <TextField
          {...params}
          id={name}
          error={Boolean(formik.errors.employerId)}
          helperText={formik.errors.employerId}
          label={label}
          variant="standard"
        />
      )}
    />
  );
};

export default EmployersAutocomplete;
